import { Api } from '../helpers';

const wfhModel = {
  makeCall(
    data,
    isUser = false,
    ifOfse = false,
    isAltContact = false,
    callee_role = null,
  ) {
    const body = data;
    let path = '';
    path = 'order/make_call';
    return Api.get({
      path,
      queryParams: {
        ...body,
        callee_role:
          isUser && isAltContact
            ? 'CUSTOMER_ALTERNATE_CONTACT'
            : callee_role || body.called_to.toUpperCase(),
      },
    });
  },

  getCallAlertData(params) {
    const queryParams = params;
    // const path = 'popups/details';
    const path = 'order/redirect_make_call';
    return Api.get({ path, queryParams });
  },

  redirectMakeCall(data) {
    const body = data;
    const path = 'popups/redirect_make_call';
    return Api.post({ path }, { body });
  },
};

export default wfhModel;
